import { Component, OnInit, Input } from '@angular/core';
import { DbRecord } from '../db-record'
import { Tag } from '../tag'
import { TagService } from '../tag.service'
import { Project } from '../project'
import { RuntimeService } from '../runtime.service'
import { Observable }  from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminService } from '../admin.service'

@Component({
  selector: 'app-tag-button',
  templateUrl: './tag-button.component.html',
  styleUrls: ['./tag-button.component.css']
})
export class TagButtonComponent implements OnInit {
  @Input() tag: Tag
  @Input() dbRecord: DbRecord

  title: string

  constructor(
    private router: Router,
    public rts: RuntimeService,
    private tags: TagService,
    private ads: AdminService
  ) { }

  ngOnInit() {

  }

  ngOnDestroy() {

  }

  get isSelected() {
    if (!this.dbRecord)
      return false
    return this.tag.isSelected(this.dbRecord)
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/tag-button/tag-button.component.ts